import type { ChatMessage as ChatMessageType } from '@/types'

interface ChatMessageProps {
  message: ChatMessageType
  currentUserId: string
}

/**
 * v5 chat row using `.ac-chat-msg`. `.is-self` adds the mint left
 * border for own messages; `.is-whisper` tints the row purple.
 */
export function ChatMessage({ message, currentUserId }: ChatMessageProps) {
  const isOwnMessage = message.userId === currentUserId
  const timestamp = new Date(message.timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  })

  const classes = [
    'ac-chat-msg',
    isOwnMessage && 'is-self',
    message.isWhisper && 'is-whisper',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes}>
      <div className="head">
        <span className="author">{message.displayName}</span>
        <span>{timestamp}</span>
        {message.isWhisper && (
          <span className="font-mono-ac" style={{ color: 'hsl(265 40% 70%)' }}>
            → whisper
          </span>
        )}
      </div>
      <div className="msg-body">{message.message}</div>
    </div>
  )
}
